import { render, staticRenderFns } from "./document-form-survey.vue?vue&type=template&id=ab27bee0&scoped=true&"
import script from "./document-form-survey.vue?vue&type=script&lang=js&"
export * from "./document-form-survey.vue?vue&type=script&lang=js&"
import style0 from "./document-form-survey.vue?vue&type=style&index=0&id=ab27bee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab27bee0",
  null
  
)

export default component.exports